document.addEventListener("change", (e) => {
  const checkbox = e.target.closest(".fembox-add-letter");
  if (!checkbox) return;

  const box = checkbox.closest(".fembox-letter-upsell");
  if (!box) return;

  const wrap = box.querySelector(".fembox-letter-message-wrap");
  if (!wrap) return;

  wrap.style.display = checkbox.checked ? "block" : "none";
});
document.addEventListener("input", (e) => {
  const textarea = e.target.closest(".fembox-letter-message");
  if (!textarea) return;

  const box = textarea.closest(".fembox-letter-upsell");
  const counter = box?.querySelector(".fembox-char-count");
  if (!counter) return;

  counter.textContent = `${textarea.value.length} / 250`;
});